function RedirectCtrl(SessionsService, $state, $timeout) {
  "ngInject";

  let vm = this;

  SessionsService.logout();

  $timeout(function () {
    $state.go('main.sign_in')
  }, 1000)


  return vm;
}
export {RedirectCtrl}
